<template>
  <div
    class="flex flex-col max-h-full px-2 py-3 pr-1 whitespace-normal bg-gray-200 list"
  >
    <div class="relative flex items-center mb-3 heading-medium">
      <h2 class="flex-grow print:border-t print:pt-3 print:pb-2">
        {{ formatDefaultFolderName(this.name) }}
      </h2>
      <button
        class="w-6 h-6 mr-1 rounded-full hover:bg-gray-400 print:hidden"
        :class="{ 'bg-gray-300': dropdownOpen }"
        @click="dropdownOpen = !dropdownOpen"
      >
        &middot;&middot;&middot;
      </button>
      <div
        @click="dropdownOpen = false"
        class="fixed inset-0 z-10 w-full h-full cursor-default"
        v-if="dropdownOpen"
        tabindex="-1"
      ></div>
      <ul
        class="absolute right-0 z-20 flex-col leading-normal bg-white border border-b-0 border-gray-300 shadow-md text-small"
        style="top: 1.7rem"
        v-show="dropdownOpen"
        @click="dropdownOpen = false"
      >
        <li class="w-40 border-b">
          <router-link
            :to="{
              name: 'editFolderList',
              params: { folderListId: this.id }
            }"
            class="flex items-center w-full px-4 py-3 font-medium whitespace-no-wrap transition duration-150 hover:text-blue text-small"
            >Liste umbenennen</router-link
          >
        </li>
        <li class="w-40 border-b" v-if="!isRoot">
          <router-link
            :to="{
              name: 'confirmDeleteFolderList',
              params: { folderListId: this.id }
            }"
            class="flex items-center w-full px-4 py-3 font-medium whitespace-no-wrap transition duration-150 hover:text-blue text-small"
            >Liste löschen</router-link
          >
        </li>
      </ul>
    </div>

    <container
      :animation-duration="50"
      :drop-placeholder="{ className: 'bg-gray-300 mr-2 mt-4' }"
      :get-child-payload="getChildPayload"
      @drop="onDrop"
      class="pr-1 overflow-x-hidden overflow-y-auto print:ml-1"
      drag-class="shadow-lg dragging print:shadow-none"
      group-name="folderList"
    >
      <draggable
        v-for="(item, index) in this.valueUnitItems"
        class="print:border-current print:border print:mb-3 print:shadow-none print:text-xs"
        :key="`item-${item.id}`"
        :set="(unit = item.valueUnit)"
        :class="{
          'mt-2': index != 0,
          'cursor-pointer': areTokensLoaded
        }"
      >
        <component
          class="shadow item group"
          :is="valueUnitComponentName(unit)"
          v-bind="unit"
          @click.native="
            areTokensLoaded &&
              onItemValueUnitClick({ ...item.valueUnit, folderItemId: item.id })
          "
        >
          <button
            class="absolute p-1 transition duration-200 rounded-full opacity-0 hover:bg-gray-400 top-1 right-1 group-hover:opacity-75"
            title="Termin/Thema aus Mappe entfernen"
            @click.stop="handleDelete(item.id)"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.11111 1.33333C10.0579 1.33333 10.8318 2.07343 10.8859 3.00665L10.8889 3.11111L10.8888 3.70362L13.2593 3.7037C13.5593 3.7037 13.8072 3.92664 13.8464 4.21588L13.8519 4.29629C13.8519 4.62357 13.5865 4.88888 13.2593 4.88888L12.6659 4.88837L12.6667 12.5926C12.6667 13.5394 11.9266 14.3133 10.9933 14.3673L10.8889 14.3704H4.96296C4.01619 14.3704 3.24228 13.6303 3.1882 12.697L3.18519 12.5926L3.18474 4.88837L2.59259 4.88888C2.29259 4.88888 2.04465 4.66595 2.00541 4.3767L2 4.29629C2 3.96901 2.26531 3.7037 2.59259 3.7037L4.96267 3.70362L4.96296 3.11111C4.96296 2.16433 5.70306 1.39042 6.63628 1.33635L6.74074 1.33333H9.11111ZM11.4812 4.88837H4.3703L4.37037 12.5926C4.37037 12.8965 4.59914 13.147 4.89385 13.1812L4.96296 13.1852H10.8889C11.1928 13.1852 11.4433 12.9564 11.4775 12.6617L11.4815 12.5926L11.4812 4.88837ZM9.11111 6.66666C9.43839 6.66666 9.7037 6.93197 9.7037 7.25925V10.8148C9.7037 11.1421 9.43839 11.4074 9.11111 11.4074C8.78383 11.4074 8.51852 11.1421 8.51852 10.8148V7.25925C8.51852 6.93197 8.78383 6.66666 9.11111 6.66666ZM6.74074 6.66666C7.06802 6.66666 7.33333 6.93197 7.33333 7.25925V10.8148C7.33333 11.1421 7.06802 11.4074 6.74074 11.4074C6.41346 11.4074 6.14815 11.1421 6.14815 10.8148V7.25925C6.14815 6.93197 6.41346 6.66666 6.74074 6.66666ZM9.11111 2.51851H6.74074C6.43684 2.51851 6.18637 2.74728 6.15213 3.042L6.14815 3.11111L6.14741 3.70362H9.70326L9.7037 3.11111C9.7037 2.8072 9.47494 2.55673 9.18022 2.5225L9.11111 2.51851Z"
                fill="#000000"
              />
            </svg>
          </button>
        </component>
      </draggable>
    </container>
  </div>
</template>
<script>
import { computed, defineComponent, ref } from "vue";
import { Container, Draggable } from "vue-smooth-dnd";
import { mapState, mapActions } from "vuex";
import {
  DpaIdCollabUnitTemplateEvent,
  DpaIdCollabUnitTemplatePicture,
  DpaIdCollabUnitTemplateText,
  DpaIdCollabUnitTemplateTopic
} from "@dpa-connect/dpa-id-collab";

import collab from "../collab";
import { EventBus } from "../eventBus";
import { formatDefaultFolderName } from "../compositions/formatDefaultFolderName";

const moveFolderItemQuery = require("../graphql/moveFolderItem.gql");
const deleteFolderItemQuery = require("../graphql/deleteFolderItem.gql");

export default defineComponent({
  setup(props) {
    const { data: folderListItems } =
      collab.DpaIdCollabGraphqlUseFolderListItems(
        computed(() => ({
          folderId: props.folderId,
          folderListId: props.id
        })),
        true
      );

    const { execute: deleteFolderItem } = collab.useMutation(
      deleteFolderItemQuery
    );

    const { execute: moveFolderItem } = collab.useMutation(moveFolderItemQuery);

    const dropdownOpen = ref(false);
    const valueUnitItems = ref([]);

    return {
      folderListItems,
      deleteFolderItem,
      moveFolderItem,
      dropdownOpen,
      valueUnitItems
    };
  },
  components: {
    Container,
    Draggable,
    DpaIdCollabUnitTemplateEvent,
    DpaIdCollabUnitTemplatePicture,
    DpaIdCollabUnitTemplateText,
    DpaIdCollabUnitTemplateTopic
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    folderId: {
      type: String,
      required: true
    },
    isRoot: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState("stageConfig", {
      agendaURL: state => state.appURL?.["dpa-Agenda"],
      selectURL: state => state.appURL?.["dpa-Select"]
    }),
    ...mapState("tokenExchange", ["agendaToken", "selectToken"]),

    hasAgendaItems() {
      const isAgendaItem = type => type === "event" || type === "topic";
      return this.valueUnitItems?.some(({ valueUnit }) => {
        return isAgendaItem(valueUnit.type);
      });
    },
    hasSelectItems() {
      const isSelectItem = type =>
        type === "text" || type === "picture" || type === "graphic";
      return this.valueUnitItems?.some(({ valueUnit }) => {
        return isSelectItem(valueUnit.type);
      });
    },
    sourceTokenMap() {
      const agenda = {
        token: this.agendaToken,
        source: "dpa-agenda"
      };
      const select = {
        token: this.selectToken,
        source: "dpa-select"
      };

      return {
        event: agenda,
        topic: agenda,
        text: select,
        picture: select,
        graphic: select
      };
    },
    areTokensLoaded() {
      const isAgendaTokenLoaded = this.hasAgendaItems
        ? !!this.agendaToken
        : true;
      const isSelectTokenLoaded = this.hasSelectItems
        ? !!this.selectToken
        : true;
      return isAgendaTokenLoaded && isSelectTokenLoaded;
    }
  },
  watch: {
    hasAgendaItems() {
      if (this.hasAgendaItems && !this.agendaToken) {
        this.fetchAgendaToken();
      }
    },
    hasSelectItems() {
      if (this.hasSelectItems && !this.selectToken) {
        this.fetchSelectToken();
      }
    },
    folderListItems: {
      deep: true,
      immediate: true,
      handler() {
        this.valueUnitItems = this.folderListItems
          .filter(item => item.type == "folderListItem") // ignore sub-folderLists
          .map(item => ({
            ...item,
            valueUnit: {
              ...item.itemValueUnit,
              ...item.itemValueUnit?.metadata
            }
          }));
      }
    }
  },
  methods: {
    ...mapActions("tokenExchange", [
      "exchangeAgendaToken",
      "exchangeSelectToken"
    ]),
    /**
     * Returns a component name for a given value unit.
     * @param {Object} unit
     * @param {String} unit.type
     * @param {String} unit.subtype
     * @param {Boolean} unit.isTopic
     * @returns {String | undefined} The matching component name
     */
    valueUnitComponentName({ type }) {
      switch (type) {
        case "picture":
          return "DpaIdCollabUnitTemplatePicture";
        case "graphic":
          return "DpaIdCollabUnitTemplatePicture";
        case "text":
          return "DpaIdCollabUnitTemplateText";
        case "topic":
          return "DpaIdCollabUnitTemplateTopic";
        default:
          return "DpaIdCollabUnitTemplateEvent";
      }
    },
    /**
     * Returns the list item that is being dragged
     * @param {Integer} index
     */
    getChildPayload(index) {
      return this.valueUnitItems[index];
    },
    onDrop(dropResult) {
      const { addedIndex, removedIndex, payload } = dropResult;

      // Do not bother the backend when moving things in place
      if (removedIndex === addedIndex) {
        return;
      }

      // Re-ordering within list
      if (removedIndex !== null && addedIndex !== null) {
        this.hideItem({ removedIndex });
        this.addItemToList({ addedIndex, payload });
      }

      // Hide the item from "another" list
      if (removedIndex !== null && addedIndex === null) {
        this.hideItem({ removedIndex });
      }

      // Add the item to "this" list
      if (addedIndex !== null && removedIndex === null) {
        this.addItemToList({ addedIndex, payload });
      }
    },
    addItemToList({ addedIndex, payload }) {
      // add visually
      this.valueUnitItems.splice(addedIndex, 0, payload);

      const previousItem = this.valueUnitItems[addedIndex - 1];
      const previousId = previousItem?.id;
      // move actually
      this.moveFolderItem({
        folderId: this.folderId,
        folderItemId: payload.id,
        newParentFolderListId: this.id,
        newPreviousFolderItemId: previousId
      }).catch(error => {
        EventBus.$emit("show", {
          title: `Fehler: Konnte nicht verschoben werden.`
        });
        console.error(error); // eslint-disable-line
      });
    },
    hideItem({ removedIndex }) {
      // remove visually
      this.valueUnitItems.splice(removedIndex, 1);
    },
    handleDelete(id) {
      const removedIndex = this.valueUnitItems.findIndex(
        item => item.id === id
      );
      // remove visually
      this.hideItem({ removedIndex });

      // remove actually
      this.deleteFolderItem({
        folderId: this.folderId,
        folderItemId: id
      })
        .then(data => {
          EventBus.$emit("show", {
            title: `Termin/Thema wurde entfernt.`,
            icon: "delete"
          });
        })
        .catch(error => {
          console.error(error); // eslint-disable-line
        });
    },
    async onItemValueUnitClick({
      previewUrl,
      metadata,
      id,
      type,
      folderItemId
    }) {
      this.$emit("openValueUnitDetail");
      this.$emit("fetchValueUnitDetailData", {
        previewUrl,
        metadata,
        id,
        type,
        folderItemId
      });
    },
    fetchAgendaToken() {
      const url = `${this.agendaURL}/useradmin/tokenexchange`;
      const ticket = this.$store.state.auth.token;
      this.exchangeAgendaToken({
        url,
        ticket
      });
    },
    fetchSelectToken() {
      const url = `${this.selectURL}/useradmin/tokenexchange`;
      const ticket = this.$store.state.auth.token;
      this.exchangeSelectToken({
        url,
        ticket
      });
    },
    formatDefaultFolderName
  },
  created() {
    EventBus.$on("delete-value-unit", ({ folderItemId }) => {
      this.handleDelete(folderItemId);
    });
  }
});
</script>

<style scoped>
.dragging {
  transform: rotate(2deg);
}

/* override overflow, otherwise the bottom shadow is hidden */
.smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper {
  overflow: visible;
}

.list {
  padding-bottom: 6px;
}

.item:hover {
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25) !important;
}

.item:last-of-type {
  margin-bottom: 6px;
}
</style>
